module.exports = __webpack_public_path__ + "img/sercomm-view_pairing-mode-light.9d7ab8dd.gif";